import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularNavigationExtrasPFE } from '../../services/pfe-navigation-service/pfe-navigation-extras';
import { PFE_STATE_NAVIGATING_TO } from '../../services/pfe-state-service/pfe-state-keys';
import { PfeStateService } from '../../services/pfe-state-service/state.service';
import { PfeBusinessService } from './../../services/pfe-business-service/business.service';
import { PfeNavigateActionConfig } from './navigate-action.model';

@Injectable()
export class PfeNavigateActionService {
  constructor(
    public router: Router,
    private navigationService: PfeBusinessService,
    private pfeStateService: PfeStateService
  ) {}

  public navigate = async (actionConfig: PfeNavigateActionConfig): Promise<boolean> => {
    const currentNavigationPFEExtras = this.router.getCurrentNavigation()?.extras as AngularNavigationExtrasPFE;
    if (currentNavigationPFEExtras?.state?.pfe?.navigatingToErrorPage) {
      return true;
    }

    if (!actionConfig.ignoreDestination) {
      const nextPage = this.pfeStateService.getStateValueByExpression(PFE_STATE_NAVIGATING_TO);
      if (nextPage !== actionConfig.pageId) {
        this.navigationService.navigateToPage(actionConfig.pageId);
        return false;
      }
      return true;
    } else {
      this.navigationService.navigateToPage(actionConfig.pageId);
      return false;
    }
  };
}
